<template>
    <div id="patients-portal-setup" class="page-height">
        <MdTitle v-bind:Text="$t('PPDbSetup.Title')" />

        <b-row>
            <b-col md="12" class="mx-auto">
                <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                    <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                        <div class="tab-pane fade show active" id="contentGeneral" role="tabpanel">
                            <tab-general
                                v-model="editableItem.setup"
                                :messageTypeList="messageTemplateSetupList"
                                :isEmailValid="isEmailValid"
                            ></tab-general>
                        </div>
                        <div class="tab-pane fade" id="menuVisibility" role="tabpanel">
                            <tab-menu-visibility ref="menuTab"></tab-menu-visibility>
                        </div>
                        <div class="tab-pane fade" id="setupEVO" role="tabpanel">
                            <tab-setup-evo v-model="editableItem.evo"></tab-setup-evo>
                        </div>
                        <div class="tab-pane fade" id="setupPayPal" role="tabpanel">
                            <tab-setup-pay-pal v-model="editableItem.payPal"></tab-setup-pay-pal>
                        </div>
                        <div class="tab-pane fade" id="setupNAB" role="tabpanel">
                            <tab-setup-nab v-model="editableItem.nab" ref="nabTab"></tab-setup-nab>
                        </div>
                        <div class="tab-pane fade" id="setup1stPay" role="tabpanel">
                            <tab-setup-first-pay
                                v-model="editableItem.firstPay"
                            ></tab-setup-first-pay>
                        </div>
                    </div>
                </MdTabList>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.BtnSave')"
                v-bind:Name="'btnSaveRole'"
                v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                v-on:click="saveOrEdit"
            />
            <MdButton
                ref="clearButton"
                v-bind:Label="$t('MdEditTableCN.Clear')"
                v-bind:Name="'btnClear'"
                v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                v-on:click="clear"
            />
        </div>
    </div>
</template>

<script>
import TabGeneral from './setup/tabGeneral.vue';
import TabSetupEvo from './setup/tabSetupEvo.vue';
import TabSetupPayPal from './setup/tabSetupPayPal.vue';
import TabSetupNab from './setup/tabSetupNab.vue';
import TabSetupFirstPay from './setup/tabSetupFirstPay.vue';
import TabMenuVisibility from './setup/tabMenuVisibility.vue';
import PatientPortalSetupService from '@/services/patientportalsetup.service.js';
import MessageTemplateSetupsService from '@/services/messagetemplatesetups.service';
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'PatientsPortalSetup',
    mixins: [ShowMessage, DBFunctions],
    components: {
        TabGeneral,
        TabSetupEvo,
        TabSetupPayPal,
        TabSetupNab,
        TabSetupFirstPay,
        TabMenuVisibility
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: ''
            },
            tablist: [
                { title: this.$t('Shared.General'), link: '#contentGeneral', active: true },
                { title: this.$t('PPDbSetup.TabList.MenuVisibility'), link: '#menuVisibility' },
                { title: this.$t('PPDbSetup.TabList.SetupEVO'), link: '#setupEVO' },
                { title: this.$t('PPDbSetup.TabList.SetupPayPal'), link: '#setupPayPal' },
                { title: this.$t('PPDbSetup.TabList.SetupNAB'), link: '#setupNAB' },
                { title: this.$t('PPDbSetup.TabList.Setup1stPay'), link: '#setup1stPay' }
            ],
            editableItem: {
                setup: null,
                firstPay: null,
                evo: null,
                payPal: null
            },
            activeTab: 1,
            messageTemplateSetupList: [],
            isEmailValid: true,
            pendingChanges: false,
            wasSaved: false
        };
    },
    computed: {
        clearButtonVisible() {
            return this.activeTab > 2;
        }
    },
    methods: {
        tabListChanged(event) {
            this.activeTab = event.activeTabNo;
            this.$refs.clearButton.showButton(this.clearButtonVisible);
        },

        clear() {
            switch (this.activeTab) {
                case 3:
                    if (this.editableItem.evo) {
                        this.editableItem.evo.apiCode = '';
                        this.editableItem.evo.apiKey = '';
                        this.editableItem.evo.apiUrl = '';
                    }
                    this.pendingChanges = true;
                    break;
                case 4:
                    if (this.editableItem.payPal) {
                        this.editableItem.payPal.clientId = '';
                        this.editableItem.payPal.clientSecret = '';
                    }
                    this.pendingChanges = true;
                    break;
                case 5:
                    if (this.editableItem.nab) {
                        this.editableItem.nab.keyExchangeUrl = '';
                        this.editableItem.nab.paypageUrl = '';
                        this.editableItem.nab.custNbr = null;
                        this.editableItem.nab.merchNbr = null;
                        this.editableItem.nab.dbaNbr = null;
                        this.editableItem.nab.terminalNbr = null;
                        this.editableItem.nab.mac = '';
                    }
                    this.pendingChanges = true;
                    break;
                case 6:
                    if (this.editableItem.firstPay) {
                        this.editableItem.firstPay.apiUrlGetCriptograma = '';
                        this.editableItem.firstPayapiUrlTransaction = '';
                        this.editableItem.firstPaymerchantKey = '';
                        this.editableItem.firstPayprocessorId = '';
                        this.editableItem.firstPayTransactionCenterId = '';
                    }
                    this.pendingChanges = true;
                    break;
                default:
            }
        },

        async saveOrEdit() {
            if (this.validate_required()) {
                await this.addOrUpdate();
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        async addOrUpdate() {
            const data = {
                setup: this.editableItem.setup,
                evo:
                    this.editableItem.evo === null ||
                    (Utils.isNullOrEmptyString(this.editableItem.evo.apiCode) &&
                        Utils.isNullOrEmptyString(this.editableItem.evo.apiKey) &&
                        Utils.isNullOrEmptyString(this.editableItem.evo.apiUrl))
                        ? null
                        : this.editableItem.evo,
                payPal:
                    this.editableItem.payPal === null ||
                    (Utils.isNullOrEmptyString(this.editableItem.payPal.clientId) &&
                        Utils.isNullOrEmptyString(this.editableItem.payPal.clientSecret))
                        ? null
                        : this.editableItem.payPal,
                firstPay:
                    this.editableItem.firstPay === null ||
                    (Utils.isNullOrEmptyString(this.editableItem.firstPay.apiUrlGetCriptograma) &&
                        Utils.isNullOrEmptyString(this.editableItem.firstPay.apiUrlTransaction) &&
                        Utils.isNullOrEmptyString(this.editableItem.firstPay.merchantKey) &&
                        Utils.isNullOrEmptyString(this.editableItem.firstPay.processorId) &&
                        Utils.isNullOrEmptyString(this.editableItem.firstPay.transactionCenterId))
                        ? null
                        : this.editableItem.firstPay,
                nab: this.isNabTabEmpty() ? null : this.editableItem.nab,
                menu: this.$refs.menuTab.getMenuItemsChanges()
            };

            await PatientPortalSetupService.addOrUpdate(data)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.wasSaved = true;
                        this.$refs.menuTab.markAsSaved();

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            this.isEmailValid =
                Utils.isNullOrEmptyString(this.editableItem.setup?.contactMessagesEmail) ||
                Utils.ValidateEmail(this.editableItem.setup?.contactMessagesEmail);

            return this.isEmailValid && this.$refs.nabTab.validate_required();
        },

        isNabTabEmpty() {
            return (
                this.editableItem.nab === null ||
                (Utils.isNullOrEmptyString(this.editableItem.nab.keyExchangeUrl) &&
                    Utils.isNullOrEmptyString(this.editableItem.nab.paypageUrl) &&
                    Utils.isNullOrEmptyString(this.editableItem.nab.custNbr) &&
                    Utils.isNullOrEmptyString(this.editableItem.nab.merchNbr) &&
                    Utils.isNullOrEmptyString(this.editableItem.nab.dbaNbr) &&
                    Utils.isNullOrEmptyString(this.editableItem.nab.terminalNbr) &&
                    Utils.isNullOrEmptyString(this.editableItem.nab.mac))
            );
        },

        async getMessageTemplateSetupAsync() {
            let params = {
                SendTo: 'PATIENT',
                ShowIn: 'PATIENTPORTAL',
                NotificationType: 'EMAIL'
            };

            await MessageTemplateSetupsService.getAll(params)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.messageTemplateSetupList = response.data.map(x => ({
                            value: x.messageType,
                            text: x.messageType
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        initializeEvents() {
            this.$nextTick(() =>
                EventBus.$on(
                    'onChanged',
                    function(e) {
                        this.pendingChanges |= e.Changed;
                    }.bind(this)
                )
            );
        },

        async loadInitialInfoAsync() {
            await PatientPortalSetupService.getAllInfo()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.editableItem = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        }
    },
    created() {
        EventBus.$on(
            'onResetTabList',
            function(item) {
                this.tabListChanged(item);
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },
    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.tabListChanged({ activeTabNo: 1 });
        Promise.allSettled([
            this.loadInitialInfoAsync(),
            this.getMessageTemplateSetupAsync()
        ]).then(() => this.initializeEvents());
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
        EventBus.$off('onResetTabList');
    },
    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('PPDbSetup.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.saveOrEdit();

                        if (this.wasSaved) {
                            next();
                        }
                    }
                });
        } else {
            next();
        }
    }
};
</script>
